// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%2364748b%27%3E%3Cpath d=%27M7 10l5 5 5-5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HomePage Styles */

.home-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0;
}

/* Hero Section */
.hero-section {
  position: relative;
  width: 100%;
  height: 400px;
  border-radius: var(--radius-2xl);
  overflow: hidden;
  margin: 2rem 1rem;
  box-shadow: var(--shadow-lg);
}

.hero-background {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, var(--primary) 0%, #7c3aed 100%);
  background-size: cover;
  background-position: center;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to right,
    rgba(55, 19, 236, 0.9),
    rgba(124, 58, 237, 0.8)
  );
  mix-blend-mode: multiply;
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  color: white;
}

.hero-title {
  font-size: 3rem;
  font-weight: 900;
  line-height: 1.1;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  letter-spacing: -0.02em;
}

.hero-subtitle {
  font-size: 1.25rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  max-width: 42rem;
  margin-bottom: 2rem;
}

/* Hero Search */
.hero-search {
  display: flex;
  gap: 0.5rem;
  width: 100%;
  max-width: 56rem;
  background-color: white;
  border-radius: var(--radius-xl);
  padding: 0.5rem;
  box-shadow: var(--shadow-xl);
}

.search-input-wrapper {
  flex: 1 1;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  border-right: 1px solid var(--slate-200);
  gap: 0.75rem;
}

.search-input-wrapper .material-symbols-outlined {
  color: var(--slate-400);
  font-size: 20px;
}

.search-input {
  flex: 1 1;
  height: 48px;
  background: transparent;
  border: none;
  outline: none;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-main);
}

.search-input::placeholder {
  color: var(--slate-400);
}

.search-btn {
  height: 48px;
  padding: 0 2rem;
  border-radius: var(--radius-lg);
  font-weight: 700;
}

/* Category Filters */
.category-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 1.5rem 2rem;
  align-items: center;
}

.filter-chip {
  display: inline-flex;
  align-items: center;
  height: 40px;
  padding: 0 1rem;
  border-radius: var(--radius-full);
  background-color: var(--surface-light);
  color: var(--text-sub);
  font-size: 0.875rem;
  font-weight: 600;
  border: 1px solid var(--slate-200);
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.filter-chip:hover {
  background-color: var(--slate-50);
  color: var(--text-main);
}

.filter-chip.active {
  background-color: var(--primary);
  color: white;
  border-color: var(--primary);
  box-shadow: 0 2px 4px rgba(55, 19, 236, 0.3);
}

.category-select-wrapper {
  margin-left: auto;
  position: relative;
}

.category-select {
  height: 40px;
  padding: 0 2.5rem 0 1rem;
  background-color: var(--surface-light);
  border: 1px solid var(--slate-200);
  border-radius: var(--radius-full);
  outline: none;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-sub);
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-fast);
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 18px;
  min-width: 12rem;
}

.category-select:hover {
  background-color: var(--slate-50);
  border-color: var(--slate-300);
}

.category-select:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-light);
  color: var(--text-main);
}

.category-select option {
  padding: 0.5rem;
  font-size: 0.875rem;
  color: var(--text-main);
}

.category-clear-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: 1px solid var(--slate-200);
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all var(--transition-fast);
  color: var(--slate-400);
  margin-left: 0.5rem;
}

.category-clear-btn:hover {
  background-color: var(--slate-100);
  border-color: var(--slate-300);
  color: var(--text-main);
}

.category-clear-btn .material-symbols-outlined {
  font-size: 18px;
}

/* Books Section */
.books-section {
  padding: 0 2rem 2rem;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.section-header h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-main);
}

.view-all-link {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--primary);
  transition: color var(--transition-fast);
}

.view-all-link:hover {
  color: var(--primary-dark);
  text-decoration: underline;
}

/* Books Grid */
.books-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;
}

@media (min-width: 640px) {
  .books-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 768px) {
  .books-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 1024px) {
  .books-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

/* Pagination */
.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  margin: 2rem 0;
  padding-bottom: 1rem;
}

.pagination-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid var(--slate-200);
  background-color: var(--surface-light);
  color: var(--text-sub);
  font-weight: 600;
  font-size: 0.875rem;
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.pagination-btn:hover:not(:disabled) {
  background-color: var(--slate-50);
  color: var(--primary);
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-btn .material-symbols-outlined {
  font-size: 20px;
}

.pagination-numbers {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.pagination-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 0 0.75rem;
  border: 1px solid var(--slate-200);
  background-color: var(--surface-light);
  color: var(--text-sub);
  font-weight: 600;
  font-size: 0.875rem;
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.pagination-number:hover {
  background-color: var(--slate-50);
  color: var(--primary);
  border-color: var(--slate-300);
}

.pagination-number.active {
  background-color: var(--primary);
  color: white;
  border-color: var(--primary);
  box-shadow: 0 2px 4px rgba(55, 19, 236, 0.3);
}

.pagination-ellipsis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  color: var(--text-sub);
  font-size: 0.875rem;
  font-weight: 600;
  -webkit-user-select: none;
          user-select: none;
}

.pagination-info {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-sub);
  padding: 0 0.5rem;
}

/* Total Count */
.total-count {
  text-align: center;
  padding: 1rem;
  color: var(--text-sub);
  font-size: 0.875rem;
  border-top: 1px solid var(--slate-200);
}

.total-count-top {
  background-color: var(--surface-light);
  border-radius: var(--radius-lg);
  margin-bottom: 1.5rem;
  border: 1px solid var(--slate-200);
  box-shadow: var(--shadow-sm);
}

.available-count {
  color: var(--success-text);
  font-weight: 600;
}

.borrowed-count {
  color: var(--borrowed-text);
  font-weight: 600;
}

/* Responsive */
@media (max-width: 768px) {
  .hero-section {
    height: 320px;
    margin: 1rem;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .hero-search {
    flex-direction: column;
    padding: 0.75rem;
  }

  .search-input-wrapper {
    border-right: none;
    border-bottom: 1px solid var(--slate-200);
    padding: 0.75rem 0;
  }

  .search-btn {
    width: 100%;
    padding: 0.75rem;
  }

  .category-filters {
    padding: 1rem;
    flex-wrap: nowrap;
    overflow-x: auto;
  }

  .category-select-wrapper {
    margin-left: 0;
    flex-shrink: 0;
  }

  .category-select {
    min-width: 10rem;
  }

  .books-section {
    padding: 0 1rem 1rem;
  }

  .books-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oEAAoE;EACpE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;GAIC;EACD,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,sCAAsC;EACtC,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,sCAAsC;EACtC,kCAAkC;EAClC,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;EAChB,yDAAqK;EACrK,4BAA4B;EAC5B,yCAAyC;EACzC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,kCAAkC;EAClC,iCAAiC;EACjC,eAAe;EACf,sCAAsC;EACtC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,qBAAqB;EACrB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF","sourcesContent":["/* HomePage Styles */\n\n.home-page {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0;\n}\n\n/* Hero Section */\n.hero-section {\n  position: relative;\n  width: 100%;\n  height: 400px;\n  border-radius: var(--radius-2xl);\n  overflow: hidden;\n  margin: 2rem 1rem;\n  box-shadow: var(--shadow-lg);\n}\n\n.hero-background {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, var(--primary) 0%, #7c3aed 100%);\n  background-size: cover;\n  background-position: center;\n}\n\n.hero-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    to right,\n    rgba(55, 19, 236, 0.9),\n    rgba(124, 58, 237, 0.8)\n  );\n  mix-blend-mode: multiply;\n  z-index: 1;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 2;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n  color: white;\n}\n\n.hero-title {\n  font-size: 3rem;\n  font-weight: 900;\n  line-height: 1.1;\n  margin-bottom: 1rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  letter-spacing: -0.02em;\n}\n\n.hero-subtitle {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.9);\n  max-width: 42rem;\n  margin-bottom: 2rem;\n}\n\n/* Hero Search */\n.hero-search {\n  display: flex;\n  gap: 0.5rem;\n  width: 100%;\n  max-width: 56rem;\n  background-color: white;\n  border-radius: var(--radius-xl);\n  padding: 0.5rem;\n  box-shadow: var(--shadow-xl);\n}\n\n.search-input-wrapper {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  padding: 0 1rem;\n  border-right: 1px solid var(--slate-200);\n  gap: 0.75rem;\n}\n\n.search-input-wrapper .material-symbols-outlined {\n  color: var(--slate-400);\n  font-size: 20px;\n}\n\n.search-input {\n  flex: 1;\n  height: 48px;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-main);\n}\n\n.search-input::placeholder {\n  color: var(--slate-400);\n}\n\n.search-btn {\n  height: 48px;\n  padding: 0 2rem;\n  border-radius: var(--radius-lg);\n  font-weight: 700;\n}\n\n/* Category Filters */\n.category-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 1.5rem 2rem;\n  align-items: center;\n}\n\n.filter-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 40px;\n  padding: 0 1rem;\n  border-radius: var(--radius-full);\n  background-color: var(--surface-light);\n  color: var(--text-sub);\n  font-size: 0.875rem;\n  font-weight: 600;\n  border: 1px solid var(--slate-200);\n  box-shadow: var(--shadow-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.filter-chip:hover {\n  background-color: var(--slate-50);\n  color: var(--text-main);\n}\n\n.filter-chip.active {\n  background-color: var(--primary);\n  color: white;\n  border-color: var(--primary);\n  box-shadow: 0 2px 4px rgba(55, 19, 236, 0.3);\n}\n\n.category-select-wrapper {\n  margin-left: auto;\n  position: relative;\n}\n\n.category-select {\n  height: 40px;\n  padding: 0 2.5rem 0 1rem;\n  background-color: var(--surface-light);\n  border: 1px solid var(--slate-200);\n  border-radius: var(--radius-full);\n  outline: none;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-sub);\n  cursor: pointer;\n  box-shadow: var(--shadow-sm);\n  transition: all var(--transition-fast);\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2364748b'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 18px;\n  min-width: 12rem;\n}\n\n.category-select:hover {\n  background-color: var(--slate-50);\n  border-color: var(--slate-300);\n}\n\n.category-select:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-light);\n  color: var(--text-main);\n}\n\n.category-select option {\n  padding: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--text-main);\n}\n\n.category-clear-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: transparent;\n  border: 1px solid var(--slate-200);\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  color: var(--slate-400);\n  margin-left: 0.5rem;\n}\n\n.category-clear-btn:hover {\n  background-color: var(--slate-100);\n  border-color: var(--slate-300);\n  color: var(--text-main);\n}\n\n.category-clear-btn .material-symbols-outlined {\n  font-size: 18px;\n}\n\n/* Books Section */\n.books-section {\n  padding: 0 2rem 2rem;\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n}\n\n.section-header h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.view-all-link {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--primary);\n  transition: color var(--transition-fast);\n}\n\n.view-all-link:hover {\n  color: var(--primary-dark);\n  text-decoration: underline;\n}\n\n/* Books Grid */\n.books-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n@media (min-width: 640px) {\n  .books-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (min-width: 768px) {\n  .books-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .books-grid {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n/* Pagination */\n.pagination-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.75rem;\n  margin: 2rem 0;\n  padding-bottom: 1rem;\n}\n\n.pagination-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1px solid var(--slate-200);\n  background-color: var(--surface-light);\n  color: var(--text-sub);\n  font-weight: 600;\n  font-size: 0.875rem;\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background-color: var(--slate-50);\n  color: var(--primary);\n}\n\n.pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-btn .material-symbols-outlined {\n  font-size: 20px;\n}\n\n.pagination-numbers {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pagination-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  height: 40px;\n  padding: 0 0.75rem;\n  border: 1px solid var(--slate-200);\n  background-color: var(--surface-light);\n  color: var(--text-sub);\n  font-weight: 600;\n  font-size: 0.875rem;\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.pagination-number:hover {\n  background-color: var(--slate-50);\n  color: var(--primary);\n  border-color: var(--slate-300);\n}\n\n.pagination-number.active {\n  background-color: var(--primary);\n  color: white;\n  border-color: var(--primary);\n  box-shadow: 0 2px 4px rgba(55, 19, 236, 0.3);\n}\n\n.pagination-ellipsis {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  height: 40px;\n  color: var(--text-sub);\n  font-size: 0.875rem;\n  font-weight: 600;\n  user-select: none;\n}\n\n.pagination-info {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-sub);\n  padding: 0 0.5rem;\n}\n\n/* Total Count */\n.total-count {\n  text-align: center;\n  padding: 1rem;\n  color: var(--text-sub);\n  font-size: 0.875rem;\n  border-top: 1px solid var(--slate-200);\n}\n\n.total-count-top {\n  background-color: var(--surface-light);\n  border-radius: var(--radius-lg);\n  margin-bottom: 1.5rem;\n  border: 1px solid var(--slate-200);\n  box-shadow: var(--shadow-sm);\n}\n\n.available-count {\n  color: var(--success-text);\n  font-weight: 600;\n}\n\n.borrowed-count {\n  color: var(--borrowed-text);\n  font-weight: 600;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .hero-section {\n    height: 320px;\n    margin: 1rem;\n  }\n\n  .hero-title {\n    font-size: 2rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1rem;\n  }\n\n  .hero-search {\n    flex-direction: column;\n    padding: 0.75rem;\n  }\n\n  .search-input-wrapper {\n    border-right: none;\n    border-bottom: 1px solid var(--slate-200);\n    padding: 0.75rem 0;\n  }\n\n  .search-btn {\n    width: 100%;\n    padding: 0.75rem;\n  }\n\n  .category-filters {\n    padding: 1rem;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n  }\n\n  .category-select-wrapper {\n    margin-left: 0;\n    flex-shrink: 0;\n  }\n\n  .category-select {\n    min-width: 10rem;\n  }\n\n  .books-section {\n    padding: 0 1rem 1rem;\n  }\n\n  .books-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
